// Central Amden Reach route configuration — the single place to change the
// canonical marketing URL and the tracked enquiry/booking links. Page content
// itself lives in the CMS (cms_listings, slug "amden-reach").
import { getEcosystemItems } from './ecosystem';

export const REACH_ROUTE = '/amden-reach';
export const REACH_LISTING_SLUG = 'amden-reach';

const TRACKING = 'interest=amden-reach&source=Reach%20Product%20Page';
export const REACH_DEMO_HREF = `/contact?${TRACKING}#book-appointment`;
export const REACH_PRICING_HREF = `/contact?${TRACKING}&topic=pricing#contact-enquiry`;

export const getReach = () =>
  getEcosystemItems().find((it) => it.slug === REACH_LISTING_SLUG) || null;
